import { Box } from "@material-ui/core";
import * as React from "react";
import { useHistory } from "react-router";
import { useRecoilValue, useRecoilValueLoadable } from "recoil";

import { Loading } from "@/components/Loading";
import { Toast } from "@/components/Toast";
import { PropertyEditPageState } from "@/view_models/atoms";
import { SelectedProperty } from "@/view_models/propertySelectors";

import { EditPropertySectionInsuranceInfo } from "./components/sections/insurance_info";
import { EditPropertySectionLeaseContract } from "./components/sections/lease_contract";
import { EditPropertySectionLoanInfo } from "./components/sections/loan_info";
import EditPropertySectionManagementBuildingCost from "./components/sections/management_building_cost";
import { EditPropertySectionManagementCost } from "./components/sections/management_cost";
import { EditPropertySectionPropertyInfo } from "./components/sections/PropertyInfo";
import { EditPropertySectionPurchaseInfo } from "./components/sections/PurchaseInfo";

export const ManagementEditPropertyPage: React.FC = () => {
  const history = useHistory();
  const property_loadable = useRecoilValueLoadable(SelectedProperty);
  // サーバーエラー
  const [serverError, setSeverError] = React.useState<string>("");
  // 表示するコンポーネント
  const propertyEditPageState = useRecoilValue(PropertyEditPageState);

  const onClickPageBack = React.useCallback(() => {
    window.scrollTo(0, 0);
    history.goBack();
  }, []);

  // サーバーエラー表示トースト
  const handleCloseToast = React.useCallback(() => {
    setSeverError("");
  }, []);

  // 物件詳細から編集ボタンを押さずに遷移してきた場合は物件詳細に遷移
  React.useEffect(() => {
    if (!propertyEditPageState) {
      history.goBack();
    }
  }, [propertyEditPageState, history]);

  if (property_loadable.state === "loading") {
    return <Loading />;
  }
  if (property_loadable.state === "hasError") {
    throw property_loadable.contents;
  }
  const property = property_loadable.contents;

  if (!property) {
    return <Loading />;
  }

  return (
    <Box>
      {/* 購入時情報 */}
      {propertyEditPageState === "purchase_info" ? (
        <EditPropertySectionPurchaseInfo propertyHolder={property} onClickPageBack={onClickPageBack} />
      ) : null}
      {/* 物件詳細 */}
      {propertyEditPageState === "property_info" ? (
        <EditPropertySectionPropertyInfo
          propertyHolder={property}
          onClickPageBack={onClickPageBack}
          setSeverError={setSeverError}
        />
      ) : null}
      {/* 経費情報 */}
      {propertyEditPageState === "management_cost" ? (
        <EditPropertySectionManagementCost
          propertyHolder={property}
          onClickPageBack={onClickPageBack}
          // setSeverError={setSeverError}
        />
      ) : null}
      {/* 一棟物件向け経費情報 */}
      {propertyEditPageState === "management_building_cost" ? (
        <EditPropertySectionManagementBuildingCost
          propertyHolder={property}
          onClickPageBack={onClickPageBack}
          // setSeverError={setSeverError}
        />
      ) : null}
      {/* 借入情報 */}
      {propertyEditPageState === "loan_info" ? (
        <EditPropertySectionLoanInfo
          propertyHolder={property}
          onClickPageBack={onClickPageBack}
          // setSeverError={setSeverError}
        />
      ) : null}

      {/* 賃貸契約情報 */}
      {propertyEditPageState === "lease_contract" ? (
        <EditPropertySectionLeaseContract
          // propertyHolder={property}
          onClickPageBack={onClickPageBack}
          // setSeverError={setSeverError}
        />
      ) : null}

      {/* 保険情報 */}
      {propertyEditPageState === "insurance_info" ? (
        <EditPropertySectionInsuranceInfo
          propertyHolder={property}
          onClickPageBack={onClickPageBack}
          // setSeverError={setSeverError}
        />
      ) : null}

      <Toast open={!!serverError} variant="error" message={serverError} onClose={handleCloseToast} />
    </Box>
  );
};
